import * as React from "react";
import Editor from "../../components/Editor";
import { Header, Button, Container } from "semantic-ui-react";
import Markdown from "../../components/WrappedMarkdown";

interface IProps {
	title: string;
	question: string;

	onBack: () => void;
	onNext: () => void;
	goHome?: () => void;
}

const TextAnswer: React.SFC<IProps> = props => (
	<div
		style={{
			flexGrow: 1,
			height: "100%",
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between"
		}}
	>
		<div>
			<Container text>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "baseline"
					}}
				>
					<div>
						<Button
							data-cy="goBack"
							onClick={props.onBack}
							basic
							circular
							icon="arrow alternate circle left"
						/>
						<Button
							onClick={props.goHome}
							basic
							circular
							icon="home"
							data-cy="goHome"
						/>
					</div>
					<Header as="h2">{props.title}</Header>
					<Button
						data-cy="goNext"
						basic
						circular
						onClick={props.onNext}
						icon="arrow alternate circle right"
					/>
				</div>
				<Markdown source={props.question} />
			</Container>
		</div>

		<div style={{ flexGrow: 1, margin: "24px 0px" }}>{props.children}</div>
		<Container text>
			<div
				style={{
					marginTop: 12,
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between"
				}}
			>
				<Button onClick={props.onBack}>Back</Button>
				<Button onClick={props.onNext}>Next</Button>
			</div>
		</Container>
	</div>
);

export default TextAnswer;



// WEBPACK FOOTER //
// ./src/pages/QuestionAnswerFragment/Layout.tsx